<template>
    <b-container>
        <b-card :title="$globalStore.translate('profile.password.change')" class="margin-bottom">
            <b-card-body>
                <b-alert variant="danger" dismissible :show="passwordError.length > 0">{{ passwordError }}</b-alert>

                <b-form @submit.prevent="changePassword">
                    <b-form-group
                        :label="$globalStore.translate('profile.password.new')"
                        label-for="inputPassword"
                    >
                        <b-form-input id="inputPassword" type="password" v-model="password"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        :label="$globalStore.translate('profile.password.new.repeat')"
                        label-for="inputPasswordRepeat"
                    >
                        <b-form-input id="inputPasswordRepeat" type="password" v-model="passwordAgain"></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="float-right">{{ 'profile.password.change.confirm' | translate }}</b-button>
                </b-form>
            </b-card-body>
        </b-card>

        <b-card :title="$globalStore.translate('profile.email.change')" class="margin-bottom">
            <b-card-body>
                <b-alert variant="danger" dismissible :show="mailError.length > 0">{{ mailError }}</b-alert>

                <b-form @submit.prevent="changeMail">
                    <b-form-group
                        :label="$globalStore.translate('profile.email')"
                        label-for="inputMail"
                        :description="$globalStore.translate('profile.email.info')"
                    >
                        <b-form-input id="inputMail" type="mail" :state="emailState" v-model="email"></b-form-input>

                        <b-form-invalid-feedback>
                            {{ 'profile.email.invalid' | translate }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="float-right">{{ 'profile.email.change.confirm' | translate }}</b-button>
                </b-form>
            </b-card-body>
        </b-card>

        <b-card :title="$globalStore.translate('profile.email.notification')" class="margin-bottom">
            <b-card-body>
                <b-form @submit.prevent="changeMailNotification">
                    <b-form-group
                    >
                        <b-form-checkbox v-model="notificationOnNewFile">
                            {{ 'profile.email.notification.receive' | translate }}
                        </b-form-checkbox>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="float-right">{{ 'profile.email.notification.save' | translate }}</b-button>
                </b-form>
            </b-card-body>
        </b-card>

        <b-card :title="$globalStore.translate('profile.language')" class="margin-bottom">
            <b-card-body>
                <b-form @submit.prevent="changeLanguage">
                    <b-form-group
                        :label="$globalStore.translate('profile.language.language')"
                        label-for="inputLanguage"
                    >
                        <b-form-select v-model="selectedLanguage">
                            <option value="de">DE</option>
                            <option value="en">EN</option>
                        </b-form-select>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="float-right">{{ 'profile.language.save' | translate }}</b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Profile",
        data() {
            return {
                password: '',
                email: '',
                originalEmail: '',
                passwordAgain: '',
                selectedLanguage: '',
                mailError: '',
                passwordError: '',
                notificationOnNewFile: false
            }
        },
        methods: {
            changePassword: function () {
                if (this.password === '' || this.passwordAgain === '') {
                    this.passwordError = this.$globalStore.translate('profile.password.empty');
                    return;
                }

                if (this.password !== this.passwordAgain) {
                    this.passwordError = this.$globalStore.translate('profile.password.not.match');
                    return;
                }

                this.passwordError = '';

                axios.patch('https://drop.rautec.de/api/me/options/password', { password: this.password }).then(response => {
                    if (response.data.error) {
                        this.$toastError('profile.saved.error', true);
                    }
                    if (response.data.success) {
                        this.$toastSuccess('profile.saved', true);
                    }

                    this.password = '';
                    this.passwordAgain = '';
                }).catch(reason => {
                    this.showRequestErrorBar();
                });
            },
            changeMail: function () {
                if (this.email === '') {
                    return;
                }

                if (this.email === this.originalEmail) {
                    return;
                }

                if (!this.isValidMail(this.email)) {
                    this.mailError = this.$globalStore.translate('profile.valid.email');
                    return;
                }

                this.mailError = '';

                axios.patch('https://drop.rautec.de/api/me/options/mail', { email: this.email }).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('profile.confirm', true);

                        this.originalEmail = this.email;
                    } else {
                        this.$toastError('profile.saved.error', true);
                    }

                    this.email = '';
                }).catch(reason => {
                    this.showRequestErrorBar();
                });
            },
            changeMailNotification: function () {
                axios.patch('https://drop.rautec.de/api/me/options/notification', { notification: +this.notificationOnNewFile }).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('profile.saved', true);
                    } else {
                        this.$toastError('profile.saved.error', true);
                    }
                }).catch(response => {
                    this.showRequestErrorBar();
                });
            },
            changeLanguage: function () {
                this.$globalStore.loadTranslation(this.selectedLanguage);

                axios.patch('https://drop.rautec.de/api/me/options/language', { language: this.selectedLanguage }).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('profile.saved', true);
                    } else {
                        this.$toastError('profile.saved.error', true);
                    }
                }).catch(response => {
                    this.showRequestErrorBar();
                });
            },
            showRequestErrorBar: function () {
                this.$toastError('profile.request.error', true);
            },
            isValidMail: function (email) {
                let mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return mailRegex.test(email.toLowerCase());
            },
            loadProfile: function () {
                axios.get('https://drop.rautec.de/api/me').then(response => {
                    if (response.data.notification) {
                        this.notificationOnNewFile = response.data.notification === 1;
                    }

                    if (response.data.language) {
                        this.selectedLanguage = response.data.language;
                    }

                    if (response.data.email) {
                        this.email = response.data.email;
                        this.originalEmail = response.data.email;
                    }
                }).catch(response => {
                    this.showRequestErrorBar();
                })
            }
        },
        computed: {
            emailState() {
                return this.email.length > 0 && this.isValidMail(this.email);
            }
        },
        mounted() {
            this.loadProfile();
        }
    }
</script>

<style scoped>
    .margin-bottom {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue